(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kauer-produktbeschrieb"] && !Shopify.designMode) return;
  try {
    
  class ProductDescriptionToggle extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.querySelector('[data-desc-wrapper]');
      this.text = this.querySelector('[data-desc-text]');
      this.toggle = this.querySelector('[data-desc-toggle]');
      if (!this.wrapper || !this.text || !this.toggle) return;

      this.handleClick = this.handleClick.bind(this);
      this.toggle.addEventListener('click', this.handleClick);

      // Startzustand: eingeklappt
      this.setState(false);

      // Button nur zeigen, wenn der Text überhaupt länger ist als die eingeklappte Höhe.
      this.checkFits = this.checkFits.bind(this);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.checkFits);
        this.resizeObserver.observe(this.text);
      }
      this.checkFits();
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this.handleClick);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    handleClick() {
      this.setState(!this.wrapper.classList.contains('is-open'));
    }

    setState(open) {
      this.wrapper.classList.toggle('is-open', open);
      this.toggle.setAttribute('aria-expanded', String(open));
    }

    checkFits() {
      const collapsed = parseFloat(getComputedStyle(this).getPropertyValue('--product-desc-collapsed-height')) || 96;
      const styles = getComputedStyle(this.wrapper);
      const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
      this.toggleAttribute('data-fits', this.text.scrollHeight + padding <= collapsed);
    }
  }

  if (!customElements.get('product-description-toggle')) {
    customElements.define('product-description-toggle', ProductDescriptionToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kauer-produktdaten-tabelle"] && !Shopify.designMode) return;
  try {
    
  class ProductSpecsTable extends HTMLElement {
    connectedCallback() {
      this.skuRow = this.querySelector('[data-sku-row]');
      this.skuValue = this.querySelector('[data-variant-sku]');
      this.barcodeRow = this.querySelector('[data-barcode-row]');
      this.barcodeValue = this.querySelector('[data-variant-barcode]');

      // Ohne SKU- und Barcode-Block gibt es nichts zu aktualisieren.
      if (!this.skuValue && !this.barcodeValue) return;

      const mapEl = this.querySelector('[data-variant-map]');
      try {
        this.variantMap = JSON.parse(mapEl.textContent);
      } catch (e) {
        this.variantMap = {};
      }

      this.handleVariantUpdate = this.handleVariantUpdate.bind(this);

      // Capture-Phase auf document: greift auch, wenn Horizon das Event auf dem
      // Section-Root feuert und es nicht bis zum document bubbelt.
      document.addEventListener('variant:update', this.handleVariantUpdate, true);

      this.startUrlFallback();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.handleVariantUpdate, true);
      this.stopUrlFallback();
    }

    handleVariantUpdate(event) {
      const detail = event.detail || {};
      const data = detail.data || {};

      // Event kam von einem anderen Produkt (z. B. Quick-Add) → ignorieren.
      const eventProductId = data.productId || (data.newProduct && data.newProduct.id);
      if (eventProductId && String(eventProductId) !== this.dataset.productId) return;

      const variant = detail.resource || detail.variant || data.variant;
      const variantId = variant && variant.id;
      if (!variantId) return;

      // Das Event funktioniert – URL-Polling wird nicht mehr gebraucht.
      this.stopUrlFallback();
      this.update(variantId);
    }

    update(variantId) {
      const key = String(variantId);
      if (Object.prototype.hasOwnProperty.call(this.variantMap, key)) {
        this.apply(this.variantMap[key]);
      } else {
        this.fetchVariant(key);
      }
    }

    apply(data) {
      data = data || {};
      this.setRow(this.skuRow, this.skuValue, data.sku);
      this.setRow(this.barcodeRow, this.barcodeValue, data.barcode);
    }

    setRow(row, valueEl, value) {
      if (!row || !valueEl) return;
      row.hidden = !value;
      valueEl.textContent = value || '';
    }

    // Varianten jenseits des Liquid-Limits von 250: Section neu vom Server holen.
    fetchVariant(variantId) {
      const url = window.location.pathname +
        '?variant=' + variantId +
        '&section_id=' + this.dataset.sectionId;

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const sku = doc.querySelector('[data-variant-sku]');
          const barcode = doc.querySelector('[data-variant-barcode]');
          const data = {
            sku: sku ? sku.textContent.trim() : '',
            barcode: barcode ? barcode.textContent.trim() : ''
          };
          this.variantMap[variantId] = data;
          this.apply(data);
        })
        .catch(() => {});
    }

    // Notnagel für Horizon-Versionen ohne variant:update. Stoppt sich selbst,
    // sobald das Event einmal angekommen ist.
    startUrlFallback() {
      this.lastUrlVariant = new URLSearchParams(location.search).get('variant');
      this.urlTimer = setInterval(() => {
        const id = new URLSearchParams(location.search).get('variant');
        if (id && id !== this.lastUrlVariant) {
          this.lastUrlVariant = id;
          this.update(id);
        }
      }, 500);
    }

    stopUrlFallback() {
      if (this.urlTimer) {
        clearInterval(this.urlTimer);
        this.urlTimer = null;
      }
    }
  }

  if (!customElements.get('product-specs-table')) {
    customElements.define('product-specs-table', ProductSpecsTable);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
